import { ReactElement, ReactNode } from 'react';
import {
  MdAddTask,
  MdDeleteOutline,
  MdOutlineEdit,
  MdOutlineFileDownload,
  MdOutlineVisibilityOff
} from 'react-icons/md';
import { RiMore2Fill } from 'react-icons/ri';
import { Event } from '@blisspointmedia/bpm-types/dist/OracleActivity';
import { Dropdown, DropdownToggleType, MenuItem } from '@Components/Dropdown';
import { Placement, StretchMode } from '@Components/designConstants';
import { useAppSelector } from '@src/redux';
import { isAdminSelector } from '@src/redux/user';
import {
  ACTIONS_MENU_CLASS,
  ACTIONS_MENU_DESTRUCTIVE_CLASS,
  ACTIONS_MENU_POPUP_CLASS,
  DetailAction,
  DetailActionType
} from '../activity-feed-constants';
import { downloadEvents } from '../activity-feed-download-utils';
import { useNotImplemented } from '../activity-feed-utils';
import { getDetailActions } from './activity-feed-detail-utils';

const ACTION_DISPLAY: Record<DetailActionType, { label: string; icon: ReactElement }> = {
  [DetailAction.HIDE]: { label: 'Hide', icon: <MdOutlineVisibilityOff /> },
  [DetailAction.CREATE_TASK]: { label: 'Create task', icon: <MdAddTask /> },
  [DetailAction.DOWNLOAD]: { label: 'Download', icon: <MdOutlineFileDownload /> },
  [DetailAction.EDIT]: { label: 'Edit', icon: <MdOutlineEdit /> },
  [DetailAction.DELETE]: { label: 'Delete event', icon: <MdDeleteOutline /> }
};

interface DetailActionsMenuProps {
  event: Event;
  showWip: boolean;
  isEditing: boolean;
  onEdit: () => void;
}

export const DetailActionsMenu = ({
  event,
  showWip,
  isEditing,
  onEdit
}: DetailActionsMenuProps): ReactNode => {
  const isAdmin = useAppSelector(isAdminSelector);
  const notImplemented = useNotImplemented();
  const actions = getDetailActions({ showWip, isAdmin, origin: event.origin });

  const options: MenuItem<DetailActionType>[] = actions.map(action => ({
    value: action,
    label: ACTION_DISPLAY[action].label,
    leadingContent: ACTION_DISPLAY[action].icon,
    disabled: action === DetailAction.EDIT && isEditing,
    className: action === DetailAction.DELETE ? ACTIONS_MENU_DESTRUCTIVE_CLASS : undefined
  }));

  const handleAction = (action: DetailActionType) => {
    if (action === DetailAction.EDIT) {
      onEdit();
      return;
    }
    if (action === DetailAction.DOWNLOAD) {
      downloadEvents([event]);
      return;
    }
    notImplemented();
  };

  return (
    <Dropdown
      type={DropdownToggleType.ICON_ONLY}
      overlayPlacement={Placement.RIGHT}
      className={ACTIONS_MENU_CLASS}
      dropdownMenuClassName={ACTIONS_MENU_POPUP_CLASS}
      ariaLabel='Event actions'
      options={options}
      onChange={handleAction}
      leadingIcon={<RiMore2Fill />}
      placeholder=''
      stretch={StretchMode.FIT}
      menuAlign='end'
    />
  );
};
